export default __webpack_public_path__ + "static/RedHatDisplay-Regular-dfe5c1e7502e7ee7e3a2b23834ee70cb.ttf";